import { useUserAccess } from '@/hooks/auth';
import { Tab, Tabs } from '@/components/ui';
import { useSetBreadcrumbs } from '@/hooks/appbar';
import { NoAccess } from '@/components/common/noaccess';
import { Locations } from '@/components/org/campus';
// import { Organization } from '@/components/org/organization';
import { Ministries } from '@/components/org/ministry';

export default function OrgPage() {
  const access = useUserAccess();
  useSetBreadcrumbs([{ label: 'Organization' }]);

  if (!access?.admin) {
    return <NoAccess />;
  }

  return (
    <Tabs variant='underlined'>
      <Tab key='locations' title='Locations'>
        <Locations />
      </Tab>
      <Tab key='ministries' title='Ministries'>
        <Ministries />
      </Tab>
      {/* <Tab key='organization' title='Organization'>
        <Organization />
      </Tab> */}
    </Tabs>
  );
}
